import type { RhinoImage } from '../..';

export function containsImage({ images, types }: { images: RhinoImage[]; types: number[] }) {
  return images.some((item) => {
    return item.type && types.includes(item.type);
  });
}
